export const rewardVoucherAmounts = Array.from(
  { length: 39 },
  (_, index) => `\u00A3${10 + index * 5}`,
);

export const rewardVoucherCriteria = [
  'Delivering work or projects outside of their objectives, such as a corporate activity',
  'Acting as a role model in demonstrating the Cabinet Office values of collaboration, trust and respect',
  'Going the extra mile',
  "Enhancing the Cabinet Office's reputation",
  'Successfully completing a difficult and important task',
  'Suggesting new ways of working which add value, reduce cost and/or improve quality',
];

export const iybCriteria = [
  'Acting outside of their objectives',
  'Acting as an outstanding role model in demonstrating the Cabinet Office values',
  'Putting in substantial additional effort to meet business goals',
  'Exceeding expectations in terms of time or quality',
  "Delivering substantial benefit to the Cabinet Office, or enhancing its reputation",
  'Successfully completing a difficult and important task',
  'Showing excellence in collaboration with colleagues',
  'Showing innovation in the way work is delivered or performed, or suggesting new ways of working which add value, reduce cost and/or improve quality',
  'Demonstrating excellent leadership behaviours across the duration of a project or a notable period of time',
  'Contributing to an inclusive working environment where all opinions and challenges are acknowledged',
];
